/* eslint-disable @typescript-eslint/no-explicit-any */
import { MultiValueTag } from "@/components/ui/MultiValueTag";
import { filterClasses, getSelectClasses } from "@/utils/filter-styles";
import { formatOptionLabel } from "@/utils/format-option-label";
import { SelectInput } from "components/Select";
import { useEffect, useRef } from "react";
import {
  useGetRegionalResponsibleQuery,
  useGetStoresOptionsQuery,
  useGetStoresResponsiblesOptionsQuery,
} from "../../../../../../services/store/select-options";
import { useFilterActions } from "../../../ducks/filter/hooks/actions";
import { useFilterState } from "../../../ducks/filter/hooks/filterState";
import {
  BALANCE_REPORT_FILTERS_STORAGE_KEY,
  DEPOSIT_STATUS_OPTIONS,
} from "../../constants";

export default function SelectFilters() {
  const { updateFilter } = useFilterActions();
  const { filters } = useFilterState();
  const isInitialized = useRef(false);

  const { data: storeOptions } = useGetStoresOptionsQuery(
    undefined,
    { refetchOnMountOrArgChange: false }
  );
  const { data: regionOptions } = useGetRegionalResponsibleQuery(
    undefined,
    { refetchOnMountOrArgChange: false }
  );
  const { data: responsibleOptions } = useGetStoresResponsiblesOptionsQuery(
    undefined,
    { refetchOnMountOrArgChange: false }
  );

  const depositOptions = DEPOSIT_STATUS_OPTIONS;

  const getStoredFilters = () =>
    JSON.parse(localStorage.getItem(BALANCE_REPORT_FILTERS_STORAGE_KEY) || "{}");
  const setStoredFilters = (filters: any) =>
    localStorage.setItem(
      BALANCE_REPORT_FILTERS_STORAGE_KEY,
      JSON.stringify(filters),
    );

  useEffect(() => {
    if (!isInitialized.current) {
      const savedFilters = getStoredFilters();

      Object.entries(savedFilters).forEach(([key, value]) => {
        updateFilter({ key, value });
      });

      isInitialized.current = true;
    }
  }, [updateFilter]);

  const handleFilterChange = (key: string) => (option: any) => {
    const value = Array.isArray(option)
      ? option.length > 0 ? option.map((opt) => opt.value) : undefined
      : option?.value;

    updateFilter({ key, value });
    updateFilter({ key: "meta", value: { page: 1 } });

    const currentFilters = getStoredFilters();
    setStoredFilters({ ...currentFilters, [key]: value });
  };

  const getCurrentSelectedOptions = (key: string, options: any[]) => {
    const filterValue = filters[key];
    if (!filterValue) return [];

    if (Array.isArray(filterValue)) {
      return options.filter(option => filterValue.includes(option.value));
    }

    const singleOption = options.find(option => option.value === filterValue);
    return singleOption ? [singleOption] : [];
  };

  const filtersData = [
    {
      key: "code",
      options: storeOptions || [],
      placeholder: "Selecionar loja",
      value: getCurrentSelectedOptions("code", storeOptions || []),
      onChange: handleFilterChange("code"),
    },
    {
      key: "responsible_id",
      options: responsibleOptions || [],
      placeholder: "Selecionar responsável",
      value: getCurrentSelectedOptions("responsible_id", responsibleOptions || []),
      onChange: handleFilterChange("responsible_id"),
    },
    {
      key: "regional_id",
      options: regionOptions || [],
      placeholder: "Selecionar regional",
      value: getCurrentSelectedOptions("regional_id", regionOptions || []),
      onChange: handleFilterChange("regional_id"),
    },
  ];

  return (
    <div className={filterClasses.container}>

      {filtersData.map((filter) => {
        const hasValue = filter.value.length > 0;

        return (
          <div key={filter.placeholder} className={filterClasses.filterItem}>
            <SelectInput
              options={filter.options}
              placeholder={filter.placeholder}
              value={filter.value}
              onChange={filter.onChange}
              className={getSelectClasses(hasValue)}
              classNamePrefix="an-simple-select"
              isMulti={true}
              isClearable
              closeMenuOnSelect={false}
              hideSelectedOptions={false}
              components={{ MultiValue: MultiValueTag }}
              formatOptionLabel={formatOptionLabel}
            />
          </div>
        );
      })}

      {(() => {
        const depositValue =
          depositOptions.find((o) => o.value === filters.depositStatus) || null;

        return (
          <div key="depositStatus" className={filterClasses.filterItem}>
            <SelectInput
              options={depositOptions}
              placeholder="Depósito (todos)"
              value={depositValue}
              onChange={handleFilterChange("depositStatus")}
              className={getSelectClasses(!!depositValue)}
              classNamePrefix="an-simple-select"
              isMulti={false}
              isClearable
            />
          </div>
        );
      })()}
    </div>
  );
}
